import { navigateTo } from '#imports'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { isShippable } from '~/scopes/checkout/utils/cart'

import { CHECKOUT } from '../../routes-names'

export function useRedirectIfMissingShippingInformation(currentStep: string) {
  const logger = useLogger()

  const redirectIfMissingShippingInformation = async (
    addressList: ApiSpecs['/bm/cart']['GET']['response']['addressList'],
    shippableCountries: ApiSpecs['/bm/cart']['GET']['response']['shippableCountries'],
  ) => {
    if (!isShippable(addressList, shippableCountries)) {
      logger.info(`[CHECKOUT][${currentStep}] Cart is not shippable`, {
        shippableCountries,
        shippingCountry: addressList.deliver?.country,
        owners: ['bot-squad-checkout-front'],
      })

      await navigateTo({ name: CHECKOUT.SHIPPING_ADDRESS })
    }
  }

  return { redirectIfMissingShippingInformation }
}
